import { render } from "./TemporaryExhibitionRegister.vue?vue&type=template&id=1c973732&scoped=true&ts=true"
import script from "./TemporaryExhibitionRegister.vue?vue&type=script&lang=ts"
export * from "./TemporaryExhibitionRegister.vue?vue&type=script&lang=ts"

import "./TemporaryExhibitionRegister.vue?vue&type=style&index=0&id=1c973732&lang=scss&scoped=true"

import exportComponent from "/app/apps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c973732"]])

export default __exports__